<template>
  <div>
    <div>
      <p class="text-sm ">
        We use GoCardless to securely manage your Direct Debit. Click the button below to get set up.
      </p>
      <DrButton class="btn-block btn-blue" :loading="loading" @click.prevent="redirectToGoCardless">
        Set up Direct Debit
      </DrButton>
    </div>
    <div class="flex items-center mt-6">
      <p class=" mb-0 pr-12 text-2xs">
        Your payments are protected by the Direct Debit Guarantee
      </p>
      <DrIcon svg="direct-debit" class="ml-3 w-1/4" scale />
    </div>
  </div>
</template>

<script>
import axiosQuoteApi from '@/services/axiosQuoteApi'

const [GoCardless] = [window.GoCardless]

export default {
  data () {
    return {
      form: {
        accountName: '',
        accountSortCode: '',
        accountNumber: '',
        dualSignatory: false,
      },
      successToken: '',
      errors: {
        frontend: {},
        goCardless: {},
      },
      showForm: false,
      loading: false,
    }
  },
  computed: {
    convertedToAccountRef: {
      get () {
        return this.$store.getters.getConvertedToAccountRef
      },
      set (value) {
        this.$store.commit('updateConvertedToAccountRef', value)
      },
    },
    quoteTotal: {
      get () {
        return this.$store.getters.getQuoteTotal
      },
      set (value) {
        this.$store.commit('updateTotal', value)
      },
    },
  },
  methods: {
    redirectToGoCardless () {
      this.loading = true
      let uri = `${process.env.VUE_APP_QUOTE_API_URL}api/gocardless/redirect/quote/${this.$store.state.quoteId}`
      if (this.$store.state.portal && this.$store.state.portal.account) {
        uri = `${uri}`
      }
      const win = window.open(uri, '_blank', 'width=660,height=607')
      const timer = setInterval(() => {
        if (win && win.closed) {
          clearInterval(timer)
          axiosQuoteApi.get(`quote/${this.$store.state.quoteId}`).then((response) => {
            if (response.data.data.convertedToAccountRef) {
              this.convertedToAccountRef = response.data.data.convertedToAccountRef
              this.quoteTotal = response.data.data.total
              this.loading = false
              this.$router.push('/success')
            } else {
              this.loading = false
            }
          })
        }
      }, 500)
    },
    checkForm () {
      this.errors.frontend = {}
      if (!this.form.accountName || !this.form.accountSortCode || !this.form.accountNumber) {
        if (!this.form.accountName) this.errors.frontend.accountName = 'Account name is required'
        if (!this.form.accountSortCode) this.errors.frontend.accountSortCode = 'Sort code is required'
        if (!this.form.accountNumber) this.errors.frontend.accountNumber = 'Account number is required'

        return
      }
      return this.submitForm()
    },
    submitForm () {
      this.loading = true
      this.errors.goCardless = {}
      GoCardless.customerBankAccountTokens.create(
        {
          publishable_access_token: process.env.VUE_APP_GOCARDLESS_PUBLISHABLE_ACCESS_TOKEN,
          customer_bank_account_tokens: {
            account_number: this.form.accountNumber,
            branch_code: this.form.accountSortCode,
            account_holder_name: this.form.accountName,
            currency: 'GBP',
            country_code: 'GB',
          },
        },
        (response) => {
          if (response.error) {
            this.loading = false
            this.errors.goCardless = response.error.errors[0]
          } else {
            axiosQuoteApi
              .post(`quote/${this.$store.state.quoteId}/payment_completed_gocardless`, {
                goCardlessToken: response.customer_bank_account_tokens.id,
              })
              .then((QuoteApiResponse) => {
                this.loading = false
                this.convertedToAccountRef = QuoteApiResponse.data.accountReference
                this.quoteTotal = QuoteApiResponse.data.data.total
                this.$router.push('/success')
              })
              .catch(() => {
                this.loading = false
                this.$router.push('/404')
              })
          }
        },
      )
    },
  },
}
</script>

<style scoped>
.right-center {
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
}

.slide-leave-active,
.slide-enter-active {
  transition: all 0.5s linear;
}

.slide-enter,
.slide-leave-to {
  max-height: 0;

  @apply py-0;
}

.slide-enter-to,
.slide-leave {
  max-height: 500px;

  @apply py-4;
}
</style>
